<template>
  <div class="home">
    <p class="tips">请输入地址点击搜索，然后点击下方显示地址，即可找到地址附近店铺，店铺名以小程序为准</p>
    <p class="tips" style="padding-top: 0">搜索小技巧：蜜雪冰城+小程序显示店名即可快速定位到附近地点，选择一个地点即可显示附近店铺</p>
    <p class="tips" style="padding-top: 0">如未找到，请输入详细地址搜索</p>
    <div class="search" >
      <el-input v-model="keyWord" class="search-ipt" placeholder="请输入地址" @input="handleInput"></el-input>
      <el-button type="primary" @click="search" style="background-color: #E60012;border-color:#E60012;">搜索</el-button>
    </div>

    <div>
      <p>附近地址</p>
      <div v-if="searchList.length===0" class="noShop">暂无符合地址</div>
      <div v-else v-for="item in searchList" :key="item.id" @click="select(item)">
        <div class="shopItem">
          <p class="shopName">{{ item.title }}</p>
          <p class="shopAdd">
            <span v-if="item.province != item.city">{{item.province}}</span>
            <span v-if="item.city">{{item.city}}</span>
            <span v-if="item.district">{{item.district}}</span>{{item.address }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {searchLocation} from '../api/mxbc'

export default {
  name: "city",
  data() {
    return {
      keyWord:'',
      searchList:[],
      timer:null
    }
  },
  mounted() {
  },
  methods: {
    search(){
      if (!this.keyWord) return this.$message.error('请输入地址')
      let params = {
        keyWord:this.keyWord
      }
      searchLocation(params).then(res=>{
        //console.log(res,'4464')
        this.searchList = res.data
      })
    },
    //点击选择地点
    select(item) {
      //console.log(item,'item')
      //this.city = city
      localStorage.setItem('city',JSON.stringify(item))
      this.$router.push({ path: "/" });
    },
    handleInput(val){
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if(val !== ''){
          this.search();
        }
      }, 1000)
    }



  }
}
</script>

<style lang="less" scoped>
.home {
  padding: 15px;
  margin-bottom: 60px;

  .search {
    width: 100%;
    margin: 0 auto 20px auto;
    display: flex;
    align-items: center;

    .search-ipt {
      margin-right: 20px;
    }
  }

  .noShop{
    margin: 20px auto;
    text-align: center;
    color: #E60012;
  }

  .shopItem {
    //min-height: 130px;
    border: 1px solid #F6E9EB;
    border-radius: 15px;
    padding: 15px;
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    //justify-content: space-around;
    color: #636363;
    .shopName{
      font-size: 18px;
      color: #000000;
    }

    .shopAdd {
      margin: 8px 0;
      //color: #636363;
    }
  }
}

.tips{
  font-size: 13px;
  padding: 10px 0;
  color: #999999;
  //display: flex;
  //flex-direction: column;
  //align-items: center;
}
</style>